// extracted by mini-css-extract-plugin
export var activeDot = "_4v-c";
export var buttonContainer = "_4v-9";
export var channelButton = "_4v-a";
export var clickable = "_4v-d";
export var content = "_4v-0";
export var contentFull = "_4v-2";
export var contentThird = "_4v-1";
export var contentWrapper = "_4v-7";
export var description = "_4v-5";
export var heightShort = "_4v-f";
export var image = "_4v-3";
export var imageContainer = "_4v-4";
export var selectButton = "_4v-e";
export var spinnerContainer = "_4v-b";
export var titleContent = "_4v-8";
export var titleWrapper = "_4v-6";